import { FC } from 'react';
import { Property } from '@model';
import { useTranslation } from 'react-i18next';
import { formatPrice } from '@utils';
import './PropertyListingPrice.scss';

export const PropertyListingPrice: FC<Property> = (props) => {
  const { t } = useTranslation();
  const priceText = formatPrice(props.price);

  return (
    <div className='product-price'>
      {!props.forSale && (
        <span>
          {priceText}
          <label>€/{t('common.perMonth')}</label>
        </span>
      )}
      {props.forSale && (
        <span>
          {priceText} <label>€</label>
        </span>
      )}
    </div>
  );
};
